// Backend configuration for Dental Triage
const getBackendUrl = () => {
  // Check if we're in production
  if (process.env.NODE_ENV === 'production') {
    // In production, use Firebase Functions (no external accounts needed)
    return 'firebase-functions';
  }
  
  // In development, use FastAPI backend
  return 'http://localhost:8000';
};

export default getBackendUrl;
